import { localImageOrigin } from './localImageOrigin';

/** 只映射开发环境的已签名图片路径，查询串逐字保留。 */
export function localImagePreviewUrl(
  url: string,
  development = import.meta.env.DEV,
  origin = import.meta.env.VITE_CPQ_LOCAL_IMAGE_ORIGIN,
): string {
  if (!development) return url;
  const prefix = `${localImageOrigin(origin)}/image?`;
  return url.startsWith(prefix)
    ? `/__cpq-local-images/image?${url.slice(prefix.length)}`
    : url;
}
